import { render, staticRenderFns } from "./CollapseListItem.vue?vue&type=template&id=71a5d4f8&scoped=true&"
import script from "./CollapseListItem.vue?vue&type=script&lang=js&"
export * from "./CollapseListItem.vue?vue&type=script&lang=js&"
import style0 from "./CollapseListItem.vue?vue&type=style&index=0&id=71a5d4f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a5d4f8",
  null
  
)

export default component.exports